module.exports = __webpack_public_path__ + "img/1fd1f7e3878dc09a1447e72e3b7915f2.svg";